import { createFileRoute } from '@tanstack/react-router';

import { SupplierSettings } from '@/features/suppliers/components/supplier-settings';

export const Route = createFileRoute(
  '/_authenticated/$tenantId/settings/suppliers',
)({
  component: SupplierSettings,
});
